module.exports = __webpack_public_path__ + "img/art752.394ad88b.png";